import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import RootLayout from "../Layouts/RootLayout";

const Home = lazy(() => import("../routes/Home"));
const Portfolio = lazy(() => import("../routes/Portfolio"));
const About = lazy(() => import("../routes/About"));
const ContactUs = lazy(() => import("../routes/ContactUs"));
const ServiceDetails = lazy(() => import("../routes/ServiceDetails"));
const ProjectDetails = lazy(() => import("../routes/ProjectDetails"));
const BlogDetails = lazy(() => import("../routes/BlogDetails"));
const Blogs = lazy(() => import("../routes/Blogs"));
const Services = lazy(() => import("../routes/Services"));
const PackagesPage = lazy(() => import("../routes/Packages"));
const NotFound = lazy(() => import("../routes/NotFound"));

function route(element) {
  return (
    <Suspense fallback={<div className="route_loader" aria-label="Loading" />}>
      {element}
    </Suspense>
  );
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: route(<Home />),
      },
      {
        path: "portfolio",
        element: route(<Portfolio />),
      },
      {
        path: "packages",
        element: route(<PackagesPage />),
      },
      {
        path: "services",
        children: [
          {
            index: true,
            element: route(<Services />),
          },
          {
            path: ":id",
            element: route(<ServiceDetails />),
          },
        ],
      },
      {
        path: "blogs",
        children: [
          {
            index: true,
            element: route(<Blogs />),
          },
        ],
      },
      {
        path: "blog-details/:id",
        element: route(<BlogDetails />),
      },
      {
        path: "project-details/:id",
        element: route(<ProjectDetails />),
      },
      {
        path: "about",
        element: route(<About />),
      },
      {
        path: "contact",
        element: route(<ContactUs />),
      },
      {
        path: "*",
        element: route(<NotFound />),
      },
    ],
  },
]);
